// extracted by mini-css-extract-plugin
export const deskHeroLeftMobile = "deskHero-module--desk-hero-left-mobile--15I0D";
export const deskHeroRightMobile = "deskHero-module--desk-hero-right-mobile--3espG";
export const deskHeroLeftTablet = "deskHero-module--desk-hero-left-tablet--10vlP";
export const deskHeroRightTablet = "deskHero-module--desk-hero-right-tablet--3LB9J";
export const deskHeroLeftDesktop = "deskHero-module--desk-hero-left-desktop--287z1";
export const deskHeroRightDesktop = "deskHero-module--desk-hero-right-desktop--djv-I";